export default {
  wrongAddressFormat: 'Wrong address format',
  disconnectWallet: 'Disconnect wallet',
  memo: 'Memo',
  stage: 'Stage',
  tokenomics: 'Tokenomics',
  tokensPurchased: 'Tokens purchased',
  youShouldAgree: 'You should agree with terms & conditions',
  requiredField: 'Required field',
  minValueIs: 'Min value is',
  maxValueIs: 'Max value is',
  cannotCopyToClipboard: 'Cannot copy to clipboard',
  copiedToClipboard: 'Copied to clipboard',
  failed: 'Action failed',
  success: 'Action was successful',
  aboutUs: 'About Us',
  bonuses: 'Bonuses',
  whitepaper: 'Whitepaper',
  team: 'Team',
  community: 'Community',
  checkAddress: 'Check address',
  currentPrice: 'CURRENT PRICE',
  bonusToBase: 'BONUS TO BASE PRICE',
  raised: 'raised',
  listingPrice: 'LISTING PRICE',
  scrollDownTo: 'Scroll down to learn more',
  keyFeaturesOf: 'Key Features of DOLLUM Wallet',
  essentialDollumFeatures:
    'Essential DOLLUM Wallet features designed for your security and convenience.',
  commissionOptimizer: 'Commission Optimizer',
  reduceTransactionCosts:
    'Reduce transaction costs by automatically choosing the lowest available fees.',
  emergencyStopMode: 'Emergency Stop Mode',
  instantlyProtectAssets:
    'Instantly protect assets by converting them to USDT in emergencies.',
  antiHijackFeature: 'Anti-Hijack Feature',
  lockYourWallet:
    'Lock your wallet under threat by activating a hidden emergency signal.',
  cryptoInvestmentPortfolio: 'Crypto Investment Portfolio',
  manageYourCrypto:
    'Manage your crypto investments with ready-to-use portfolios in one click.',
  backupAddress: 'Backup Address',
  redirectAssetsTo:
    'Redirect assets to a backup address after extended periods of inactivity.',
  bonusStages: 'BONUS STAGES',
  over320Million:
    'Over 320 million people use cryptocurrencies globally, creating a growing demand for secure crypto wallets and financial solutions.',
  tokenStructure: 'TOKEN STRUCTURE',
  onlyEmtVill: 'ONLY 210,000,000 EMT WILL BE ISSUED DURING THE PRESALE!',
  remainingTokens: 'Tokens Sold',
  totalRaised: 'Total tokens sold',
  other: 'Other',
  is: 'is',
  connectWallet: 'Connect wallet',
  operationInProgress: 'Transaction in progress',
  pleaseWait: 'Please wait',
  buying: 'Buying',
  for: 'for',
  confirmThisTransaction: 'Confirm this transaction in your wallet',
  changeMetamaskWallet: 'Change Metamask Wallet',
  connectedWith: 'Connected with',
  copyAddress: 'Copy Address',
  viewOnExplorer: 'View On Explorer',
  checkAddressText:
    'You can enter the address of the wallet you used to purchase our tokens to view their amount and status.',
  frozenFor: 'Frozen for ',
  month: 'month',
  months: 'months',
  scheduleOfThe: 'Schedule of the sequence of funds defrosting',
  back: 'BACK',
  available: 'Available',
  buy: 'Buy',
  enterTheWallet:
    'Enter the address where you would like to receive the DOLLUM token.',
  addressMustBe: 'Use only the BSC network to receive your tokens safely',
  youAreAt: 'You are at step',
  of: 'of',
  notUseExchangeWallets:
    'Use only DeFi wallets (e.g. MetaMask, Trust Wallet, Coinbase Wallet). Do not use exchange wallets',
  continue: 'Continue',
  youAreOnLast: 'You are on the last step',
  youMustTransfer: 'You must transfer funds in the amount of',
  address: 'Address',
  thisOperationTakes: 'The transaction takes up to 3 hours to complete',
  update: 'Update',
  copyTransactionHash: 'Copy transaction hash',
  copy: 'Copy',
  depositTheSpecified: 'Deposit the specified funds to this wallet',
  balance: 'Balance',
  receive: 'Receive',
  theOperationSuccessful: 'The transaction is successful',
  yourFundsWill: 'Your funds will be transferred to your wallet',
  afterTheCompletion:
    'After the completion of all presale rounds, the DOL token unlocking process will begin',
  theAmountOf: 'The amount of',
  setOneText1: '$1.5 billion crypto wallet market value in 2023',
  setOneText2: '40% of market revenue driven by crypto trading',
  setOneText3: '50% growth in crypto remittances over the next decade',
  setTwoText1: '70% of users prefer staking and DeFi integration',
  setTwoText2: '$175 million potential revenue from token sales',
  setTwoText3: '10% of total supply allocated for marketing initiatives',
  metric: 'Metric',
  currentMarketState: 'Current Market State',
  forecastedGrowth: 'Forecasted Growth',
  userSegments: 'User Segments',
  opportunitiesForDollum: 'Opportunities for DOLLUM Wallet',
  marketValue: 'Market Value',
  retailInvestorsFinancial: 'Retail investors, financial institutions',
  increasingDemandFor: 'Increasing demand for crypto wallets',
  numberOfCrypto: 'Number of Crypto Users',
  expectedToReach: 'Expected to reach 500+ million by 2030',
  youthEntrepreneursInstitutional:
    'Youth, entrepreneurs, institutional clients',
  attractNewUsers: 'Attract new users through DeFi',
  mobileWalletShare: 'Mobile Wallet Share',
  belongsToAndroid: '45% of the market belongs to Android',
  mobileSolutionsExpected: 'Mobile solutions expected to grow by 10% annually',
  smartphoneUsers: 'Smartphone users',
  convenienceAndMobile: 'Convenience and mobile access',
  defiAndStacking: 'DeFi and Staking',
  integrationWithDefi: 'Integration with DeFi protocols',
  exponentialGrowthIn: 'Exponential growth in demand for DeFi services',
  activeCryptoInvestors: 'Active crypto investors',
  directAccessTo: 'Direct access to staking and DEX',
  marketRegions: 'Market Regions',
  marketLeaders: 'Market leaders: North America, Asia',
  asiaAndLatin: 'Asia and Latin America – most promising',
  entrepreneursAndLow: 'Entrepreneurs and low-income users',
  expansionIntoNew: 'Expansion into new markets',
  millionCryptoUsers: 'million crypto users worldwide',
  allocationOfFunds: 'ALLOCATION OF FUNDS',
  seedRound: 'Seed round',
  round: 'round',
  Round: 'Round',
  tokenPrice: 'Token price',
  privateRound: 'Private round',
  presaleRound: 'Presale round',
  publicSaleRound: 'Public sale round',
  marketingCommunityBuilding: 'Marketing, Community building, Airdrop',
  teamAndFounders: 'Team and Founders',
  ecosystemDevelopmentFund: 'Ecosystem Development Fund',
  liquidityFund: 'Liquidity Fund',
  stakingRewards: 'Staking rewards',
  reserveFund: 'Reserve Fund',
  usersChooseStaking: '70% of users choose staking in DOLLUM',
  theMajorityOf:
    'The majority of DOLLUM Wallet users actively engage in staking to earn steady income and participate in DeFi ecosystem growth, benefiting from high APY and the wallet’s security.',
  preliminaryEstimateBased:
    '**This is a preliminary estimate based on current market trends.',
  roadmapText1: 'Non custodial wallet',
  roadmapText1Part2: 'Core custodial features',
  roadmapText1Part3: 'Whitepaper',
  roadmapText2: 'Non custodial wallet',
  roadmapText2Part2: 'Core custodial features ',
  roadmapText2Part3: 'Whitepaper ',
  roadmapText3: 'Anti hijack',
  roadmapText3Part2: 'Wallet Launch ',
  roadmapText3Part3: 'Backup address feature',
  roadmapText3Part4: 'Emergency transfer ',
  roadmapText3Part5: 'Portfolio manager',
  roadmapText4: 'Tokenomics and Token sale',
  roadmapText4Part2: 'Commission optimizer',
  roadmapText4Part3: 'Messages inside transaction',
  roadmapText5: 'NFT inside wallet',
  roadmapText5Part2: 'Buy crypto with fiat',
  roadmapText5Part3: 'Swap using the non-custodial wallet feature',
  roadmapText6: 'Public Beta',
  roadmapText6Part2:
    'Strategic alliances with global banking institutions to integrate the DOL token as a dollar-standard asset.',
  roadmapText6Part3: 'Bank cards',
  roadmapText6Part4: 'Listing on Crypto Exchanges',
  roadmapText6Part5: 'Dollum cryptoexchange beta',
  roadmapText7: 'Wallet Launch',
  roadmapText7Part2:
    'Adoption of the DOL token as a digital instrument for government-led initiatives.',
  roadmapText7Part3: 'Dollum blockchain',
  roadmapText7Part4: 'NFT Marketplace beta',
  roadmapText8: 'Cryptoexchange launch',
  roadmapText8Part2: 'NFT Marketplace launch',
  tokenRoadmap: 'token Roadmap',
  roadmap: 'Roadmap',
  competitorComparison: 'competitor Comparison',
  featureAttribute: 'Feature/Attribute',
  typeOfWallet: 'Type of Wallet',
  custodialNonCustodial: 'Custodial & Non-custodial',
  nonCustodial: 'Non-custodial',
  cryptocurrenciesSupported: 'Cryptocurrencies Supported',
  bitcoinEthereumTron: 'Bitcoin, Ethereum, Tron, Polygon, and more',
  thousandCoins: '1,000+ coins',
  ethereumTokens: 'Ethereum, ERC-20 tokens',
  assets130: '130+ assets',
  assets500: '500+ assets',
  supportedPlatforms: 'Supported Platforms',
  defiIntegration: 'DeFi Integration',
  yes: 'Yes',
  stakingSupport: 'Staking Support',
  no: 'No',
  tokenSwapping: 'Token Swapping',
  yesNativeExternal: 'Yes (native & external)',
  securityFeatures: 'Security Features',
  biometricPassword: 'Biometric, Password',
  passwordPrivateKey: 'Password, Private Key',
  biometric2Fa: 'Biometric, 2FA',
  kycCompliance: 'KYC/AML Compliance',
  yesForCustodial: 'Yes (for custodial)',
  backupRecovery: 'Backup & Recovery',
  yesSeedPhrases: 'Yes (seed phrases, 2FA)',
  yesSeedPhrase: 'Yes (seed phrase)',
  supportedBlockchains: 'Supported Blockchains',
  multiBlockChainCustom: 'Multi-blockchain (customizable)',
  multiBlockchain: 'Multi-blockchain',
  userInterface: 'User Interface',
  intuitiveCustomizable: 'Intuitive, customizable (dark/light theme)',
  simpleCleanInterface: 'Simple, clean interface',
  simpleDeveloperFocused: 'Simple, developer-focused',
  cleanAndUser: 'Clean and user-friendly',
  visualAppealing: 'Visually appealing, customizable',
  cleanSimple: 'Clean, simple',
  crossChainSwapping: 'Cross-Chain Swapping',
  fees: 'Fees',
  adjustableOptimizedUsing: 'Adjustable, optimized using Commission Optimizer',
  adjustable: 'Adjustable',
  fixedForCustodial: 'Fixed for custodial; adjustable for non-custodial',
  backupAddressFeature: 'Backup Address Feature',
  yesNonCustodial: 'Yes (non-custodial)',
  pushNotifications: 'Push Notifications',
  hardwareWalletSupport: 'Hardware Wallet Support',
  yesViaTrezor: 'Yes (via Trezor)',
  yesLedgerTrezor: 'Yes (Ledger/Trezor)',
  yesTrezor: 'Yes (Trezor)',
  yesLedger: 'Yes (Ledger)',
  nftSupport: 'NFT Support',
  feeOptimization: 'Fee Optimization',
  yesCommissionOptimizer: 'Yes (Commission Optimizer)',
  twoFactorAuth: 'Two-Factor Authentication (2FA)',
  fiatConversion: 'Fiat Conversion',
  yesCustodialOnly: 'Yes (custodial only)',
  mobileSpecificFeatures: 'Mobile-Specific Features',
  storiesEmergencyStop: 'Stories, Emergency Stop, Anti-Hijack',
  none: 'None',
  adminPanel: 'Admin Panel',
  yesCustodialService: 'Yes (for custodial service)',
  nativeDexAddress: 'Native DEX Access',
  decentralizedAppBrowser: 'Decentralized App Browser',
  biometricLogin: 'Biometric Login',
  reputationSystem: 'Reputation System',
  yesInternalWallet: 'Yes (internal wallet rating)',
  additionalSecurityTools: 'Additional Security Tools',
  emergencyStopAnti: 'Emergency Stop, Anti-Hijack',
  languagesSupport: 'Languages Supported',
  multiLanguageSupport: 'Multi-language support',
  english: 'English',
  customerSupport: 'Customer Support',
  yesBuildIt: 'Yes (built-in support options)',
  yesHelpCenter: 'Yes (help center)',
  yes24Support: 'Yes (24/7 support)',
  yesInApp: 'Yes (in-app support)',
  frequentlyAskedQuestions: 'FREQUENTLY ASKED QUESTIONS',
  howFindFrequently:
    'Here you can find all the frequently asked questions about our product',
  faqTitle1: 'How do I create a wallet in DOLLUM Wallet?',
  faqTitle2: 'What fees does DOLLUM Wallet charge?',
  faqTitle3: 'Does the wallet support DeFi integration?',
  faqTitle4: 'How do I use the Emergency Stop feature?',
  faqTitle5: 'Can DOLLUM Wallet be used to store NFTs?',
  faqTitle6: 'How can I recover wallet access if my device is lost?',
  faqText1:
    'To create a wallet, simply download the app, complete registration, choose wallet type (custodial/non-custodial), and securely store your seed phrase for access.',
  faqText2:
    'DOLLUM Wallet automatically optimizes transaction fees by selecting the lowest available rates, minimizing user costs during operations.',
  faqText3:
    'Yes, DOLLUM Wallet fully supports DeFi protocols, allowing users to participate in staking, farming, and token swaps through integrated DEXs.',
  faqText4:
    "The Emergency Stop feature instantly converts assets to stablecoins or locks the wallet if security is threatened. It can be activated via the wallet's settings.",
  faqText5:
    'Yes, DOLLUM Wallet supports the storage, viewing, and trading of NFTs, allowing users to securely manage their digital collections directly within the wallet.',
  faqText6:
    'You can restore access to your wallet using the seed phrase that was provided during wallet creation. Make sure to store the seed phrase in a secure location.',
  footerReservedText:
    'The website is operated by SecureLabs LTd incorporated under the laws of Seychelles,  registered address: Suite 1, Second Floor, Sound & Vision House, Rue Pierre De Possession, Victoria, Mahe, Seychelles. All rights reserved',
  termsOfUse: 'Terms of use',
  privacyPolicy: 'Privacy Policy',
  cookiePreferences: 'Cookie Preferences',
  agreeToTransaction:
    'I agree to the transaction, as well as to the clauses described in the ',
  and: 'and',
  termsAndConditions: 'Terms and Conditions',
  alsoYouCan: 'Also you can verify the confirmation of your allocation on ',
  usingTheTransaction:
    'using the transaction hash. You can always view the detailed unlocking schedule of your DOL tokens on this site by providing the receiving address.',
  followUsOn: 'Follow us on social media',
  lockedFor: 'Locked for',
  selectNetwork: 'Select network',
  dolTokenWill: 'DOL Token will be launched On Binance Smart Chain Network',
  copyTxHash: 'Copy tx hash',
  theOperationExpired: 'The operation has expired',
  waitingTimeHas: 'Waiting time has expired, try again',
  ifTheProblem: 'If the problem recurs, please ',
  sendUsEmail: 'send us an email',
  contactSupport: 'contact support',
  tryAgain: 'Try again',
  theOperationFailed: 'The operation has failed',
  error: 'Error',
  tokenUnlockingSchedule: 'Token Unlocking Schedule:',
  promoCodeUsed: 'Promo code has been successfully used',
  congratulations: 'Congratulations',
  youCanActivate: 'You can activate the promo code for ',
  activateYourPromocode: 'Activate your promocode',
  getting: 'Getting',
  totalRaisedInUsd: 'Total raised',

  nextStage: 'Next stage',
  pay: 'Pay',
  info: 'Info',
  dollumApp: 'Dollum App',
  trustApp: 'Trust App',
  metamask: 'Metamask',
  coinbaseApp: 'Coinbase App',
  exodusApp: 'Exodus App',
  cryptoComDefi: 'Crypto.com DeFi',
  bonusRowsState1: '$1.5 billion in 2023',
  bonusRowsGrowth1: '$1.5 billion in 2023',
  bonusRowsState2: '320+ million crypto users',
  multiformatSupport: 'Bitcoin, Ethereum, ERC-20',
  iosAndroidDesktopLightVersion: 'iOS, Android, Desktop (Light Version)',
  iosAndroid: 'iOS, Android',
  iosAndroidChrome: 'iOS, Android, Chrome',
  iosAndroidBrowser: 'iOS, Android, Browser',
  iosAndroidDesktop: 'iOS, Android, Desktop',
  biometricPin2Fa:
    'Biometric, PIN, 2FA, SSL pinning, AES-256 encryption, `Emergency Stop`, `Anti-Hijack`',
  ethereum: 'Ethereum',

  poweredBy: 'Powered by',
  live: 'Live',

  auditAndKycVerified: 'Audit & KYC Verified',
  teamKycVerification: 'Team KYC Verification',
  smartContractAudit: 'Smart Contract Audit',
  securityComesFirst: 'Security comes first.',
  ourSmartContractHasBeenFullyAudited:
    'Our smart contract has been fully audited',
  bySolidProof: 'by SolidProof,',
  oneOfTheLeadingBlockchainAuditFirms:
    'one of the leading blockchain audit firms.',
  additionally: 'Additionally,',
  dollumTeamCompletedKYC:
    'the Dollum team successfully completed the KYC verification',
  ensuringTransparencyAndAccountability:
    ', ensuring transparency and accountability for our community.',
  servicesAndCertificates: 'Services & Certificates',
  kyc: 'KYC',
  securityScore: 'Security Score',
  poor: 'Poor',
  excellent: 'Excellent',
  writesMediaAboutUs: 'Media about us',

  stageTwoAlmostSold: 'Stage 2 Almost Sold Out — Next Price: $0.20',
  buyBeforeThePriceIncreases: 'Buy now at $0.15 before the price increases!',

  useOnlyDefiWallet:
    'Use only a DeFi wallet such as MetaMask, Trust Wallet, or Coinbase Wallet.',
  makeSureYourWalletIsConnectedToTheBsc:
    'Make sure your wallet is connected to the BSC (Binance Smart Chain) network.',
  copyYourBscWalletAddress:
    'Copy your BSC wallet address (it starts with 0x) and paste it into the field.',
  doNotUseExchangeWallets:
    'Do not use exchange wallets (like Binance, KuCoin, or OKX).',

  needHelp: 'Need help?',

  stage3IsSellingFast: 'Final Presale Stage — Last Chance Before Listing',
  nextStagePriceIncreases:
    'Secure your tokens now before the planned initial listing price of $1.00',
  finalPresaleStage: 'Final Presale Stage',

  dollumWallet: 'Dollum Wallet',
  launchingSoon: 'Launching Soon',
  hour: 'Hour',
  minute: 'Minute',
  second: 'Second',
  days: 'Days',

  weAreLive: 'We’re Live!',
  weWillLiveSoon: "We'll live soon",
  startManagingYourCryptoSecurely: 'Start managing your crypto securely ',

  launchpadIntroduction: 'Launchpad introduction',
  continuedPlatformDevelopment:
    'Continued platform development and ecosystem expansion',
  expansionIntoIntegratedFinancialServices:
    'Expansion into integrated financial services, including payment and borrowing capabilities',
  ecosystemScaling: 'Ecosystem scaling and feature expansion',
  platformOptimizationAndInfrastructure:
    'Platform optimization and infrastructure strengthening',
  platformForBroaderMarketIntegration:
    'Preparation for broader market integration',
  structuredDigitalFinanceEcosystem: 'A STRUCTURED DIGITAL FINANCE ECOSYSTEM',
  dollumCombinesSecureWallet:
    'Dollum combines secure wallet infrastructure, staking, and integrated financial tools within a unified platform — extending into payment and borrowing capabilities.',

  digitalFinancePlatform: 'A digital finance platform with integrated payments',
  mRaised: '$100M+ raised',
  finalStageLimitedAllocationRemaining:
    'Final stage - limited allocation remaining',

  nowAvailable: 'Now available',
  digitalAssetManagement:
    'Digital asset management with integrated payment capabilities',
};
